import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
  flex-direction: row;
  gap: 12px;
`;

export const IconWrapper = styled.div<{ url: string }>`
  width: 36px;
  &:before {
    display: block;
    position: relative;
    content: "";
    width: 24px;
    height: 24px;
    background: url(${p => p.url}) no-repeat;
    background-size: contain;
  }
`;

export const ContentWrapper = styled.div`
  flex-direction: column;
  max-width: calc(100% - 36px);
`;

export const Title = styled.div`
  ${FONTS.XS};
  color: ${COLORS.TextHint};
`;

export const Content = styled.div`
  ${FONTS.S};
  color: ${COLORS.TextPrimary};
`;
